import { useCallback, useEffect, useState } from 'react';
import { sortiereFuerBrett, type PollView } from '../../shared/polls';
import { pollsApi } from './api';

/**
 * Abfragen fuer Strip und Schwarzes Brett. Anders als die Ankuendigungen nicht
 * direkt per RLS, sondern ueber /api/polls – dort entscheidet der Server, wer
 * welche Zahlen sieht (Design-System §6 „Abfrage“).
 *
 * Schlaegt der Abruf fehl, bleibt das Brett nutzbar: dann eben ohne Abfragen.
 */
export function usePolls(): { polls: PollView[]; reload: () => Promise<void> } {
  const [polls, setPolls] = useState<PollView[]>([]);

  const reload = useCallback(async () => {
    try {
      setPolls(sortiereFuerBrett(await pollsApi.list()));
    } catch {
      setPolls([]);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { polls, reload };
}
